import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type HubspotFormData = {
    email: string;
    firstname: string;
    lastname: string;
    company: string;
    subject: string;
    message: string;
    fileUrls?: string[];
};

export type HubspotUploadResponse = {
    urls: string[];
};

export type HubspotSubmissionPayload = {
    fields: { name: string; value: string }[];
    context: {
        pageUri: string;
        pageName: string;
    };
};

@Injectable({ providedIn: 'root' })
export class HelpHubspotService {
    private http = inject(HttpClient);

    uploadFiles(files: File[]): Observable<HubspotUploadResponse> {
        const formData = new FormData();
        files.forEach(file => formData.append('files', file));

        return this.http.post<HubspotUploadResponse>(
            '/members/hubspot/upload-files',
            formData
        );
    }

    submitForm(hubspotId: number, formUuid: string, data: HubspotFormData): Observable<void> {
        const url = `https://api.hsforms.com/submissions/v3/integration/submit/${hubspotId}/${formUuid}`;

        const fields = [
            { name: 'email', value: data.email },
            { name: 'firstname', value: data.firstname },
            { name: 'lastname', value: data.lastname },
            { name: 'company', value: data.company },
            { name: 'TICKET.subject', value: data.subject },
            { name: 'TICKET.content', value: data.message },
        ];

        if (data.fileUrls && data.fileUrls.length > 0) {
            data.fileUrls.forEach(fileUrl =>
                fields.push({ name: 'TICKET.hs_file_upload', value: fileUrl })
            );
        }

        const payload: HubspotSubmissionPayload = {
            fields,
            context: {
                pageUri: window.location.href,
                pageName: 'Help Form',
            },
        };

        return this.http.post<void>(url, payload);
    }
}
